import { useLazyQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';

import Booking, { BookingByBoutiqueInput } from '../models/Booking';
import { GET_BOOKING_BY_BOUTIQUE } from './query';

interface QueryData {
  booking: Booking;
}

interface QueryVariables extends BookingByBoutiqueInput {}

/**
 * Fetch a specific booking
 */
function useFetchBooking() {
  const { boutiqueId = '' } = useParams();

  const [execute, { loading, error, data }] = useLazyQuery<QueryData, QueryVariables>(GET_BOOKING_BY_BOUTIQUE, {
    notifyOnNetworkStatusChange: true,
  });

  const fetchBooking = async (): Promise<Booking | undefined> => {
    const variables: QueryVariables = {
      boutiqueId,
    };

    const response = await execute({ variables });

    return response.data?.booking;
  };

  return { fetchBooking, loading, error, data: data?.booking };
}

export default useFetchBooking;
